// Per-platform display metadata for the scheduler — icon glyph, brand
// color, human label. Used by MonthGrid tile chips + ScheduleModal's
// platform picker. Keys match the backend's _SCHEDULER_PLATFORMS set.
//
// To add a new platform: add a key here, add it to backend
// _SCHEDULER_PLATFORMS, run the migration script (none needed for
// scheduler — column is a free `text`).

export interface PlatformMeta {
  label: string;
  icon: string;   // Remix Icon class
  color: string;  // brand color, hex
}

export const PLATFORM_META: Record<string, PlatformMeta> = {
  instagram: { label: 'Instagram', icon: 'ri-instagram-line',       color: '#E4405F' },
  facebook:  { label: 'Facebook',  icon: 'ri-facebook-circle-line', color: '#1877F2' },
  x:         { label: 'X',         icon: 'ri-twitter-x-line',       color: '#0F1419' },
  tiktok:    { label: 'TikTok',    icon: 'ri-tiktok-line',          color: '#0F0F0F' },
  // LinkedIn meta kept for graceful rendering of any historical
  // scheduled_posts row whose platform column already says 'linkedin'.
  // Not in PLATFORM_PICK_ORDER, so users can't schedule new LinkedIn
  // posts via the UI from June 7 onward (replaced by TikTok in the
  // Connect group). Drop this entry entirely once any old rows are
  // migrated away.
  linkedin:  { label: 'LinkedIn',  icon: 'ri-linkedin-box-line',    color: '#0A66C2' },
  // Fallback for any unknown id the backend may return — keeps the UI
  // from crashing on a future platform we haven't styled yet.
  default:   { label: 'Other',     icon: 'ri-share-line',           color: '#6B7280' },
};

/** Ordered list of pickable platforms (drives the modal's chip row).
 *  Only Instagram + Facebook ship with real OAuth + posting; TikTok + X
 *  (and LinkedIn earlier) are NOT integrated, so they were removed from
 *  the pickable set (Jul 19) — their PLATFORM_META entries stay above
 *  purely as a defensive fallback for any historical row.
 *
 *  This list is ALSO the canonical "supported platforms" list for the
 *  app-wide sidebar Connect group (AppLayoutV2). Both surfaces import
 *  from here so they can't drift — adding a new platform here makes it
 *  appear in BOTH the sidebar AND the schedule modal at once. */
export const PLATFORM_PICK_ORDER = ['instagram', 'facebook'] as const;
export type SupportedPlatform = typeof PLATFORM_PICK_ORDER[number];
